import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X, Leaf } from "lucide-react";
import { NAV_LINKS } from "@/data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  useLocation();

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 w-full z-50 bg-[#0f1410]/85 backdrop-blur-xl border-b border-[#1b4d22]/40"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[70px] flex items-center justify-between">
        <NavLink
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
          onClick={() => setOpen(false)}
        >
          <Leaf className="w-6 h-6 text-[#d4af37] group-hover:rotate-12 transition-transform" />
          <span className="font-heading font-bold text-lg md:text-xl uppercase tracking-wide text-white">
            La Giungla <span className="text-[#d4af37]">SMP</span>
          </span>
        </NavLink>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s|&/g, "")}`}
              className={({ isActive }) =>
                `font-heading uppercase text-sm tracking-widest transition-colors ${
                  isActive
                    ? "text-[#d4af37]"
                    : "text-[#e0e0e0] hover:text-[#d4af37]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#d4af37]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#0f1410] border-t border-[#1b4d22]/40 px-5 py-4 flex flex-col gap-4"
        >
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `font-heading uppercase text-base tracking-widest ${
                  isActive ? "text-[#d4af37]" : "text-[#e0e0e0]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
};
